import { IconsType } from '../../shared'
import { ColorsV2 } from '../../../design-system/colors_v2'
import { SelectOption } from '../../../model/SelectOption'
import {
  SessionHistoryEvent,
  SessionHistoryEventType,
  SessionHistoryStatusFilter,
} from '../../../model/UserSession'
import { toDate } from '../../../misc/date.utilities'

export type HistoryEventStatusVariant = 'success' | 'error' | 'neutral'

export interface HistoryEventDisplay {
  label: string
  icon: IconsType
  iconColor: ColorsV2
  statusVariant: HistoryEventStatusVariant
  isError: boolean
}

export interface SessionHistoryListItem extends SessionHistoryEvent {
  id: string
}

export const getHistoryEventDisplay = (event: SessionHistoryEvent): HistoryEventDisplay => {
  switch (event.type) {
    case SessionHistoryEventType.Login:
      return {
        label: 'Connexion réussie',
        icon: 'checkCircle',
        iconColor: ColorsV2.success,
        statusVariant: 'success',
        isError: false,
      }
    case SessionHistoryEventType.Logout:
      return {
        label: 'Déconnexion',
        icon: 'checkCircle',
        iconColor: ColorsV2.info,
        statusVariant: 'neutral',
        isError: false,
      }
    case SessionHistoryEventType.LoginError:
      return {
        label: 'Échec de connexion',
        icon: 'crossCircle',
        iconColor: ColorsV2.error,
        statusVariant: 'error',
        isError: true,
      }
    case SessionHistoryEventType.LogoutError:
      return {
        label: 'Échec de déconnexion',
        icon: 'crossCircle',
        iconColor: ColorsV2.error,
        statusVariant: 'error',
        isError: true,
      }
    default:
      return {
        label: String(event.type ?? 'Évènement'),
        icon: 'infoCircle',
        iconColor: ColorsV2.info,
        statusVariant: 'neutral',
        isError: false,
      }
  }
}

export const STATUS_FILTER_OPTIONS: Array<SelectOption<SessionHistoryStatusFilter>> = [
  { value: SessionHistoryStatusFilter.All, label: 'Tous' },
  { value: SessionHistoryStatusFilter.Success, label: 'Succès' },
  { value: SessionHistoryStatusFilter.Error, label: 'Échecs' },
]

export const filterEventsByStatus = (
  events: SessionHistoryEvent[],
  status: SessionHistoryStatusFilter,
): SessionHistoryEvent[] => {
  if (status === SessionHistoryStatusFilter.All) {
    return events
  }

  const wantError = status === SessionHistoryStatusFilter.Error
  return events.filter((event) => getHistoryEventDisplay(event).isError === wantError)
}

export const sortByTimeDesc = (events: SessionHistoryEvent[]): SessionHistoryEvent[] =>
  [...events].sort((a, b) => {
    const dateA = toDate(a.time)?.getTime() ?? 0
    const dateB = toDate(b.time)?.getTime() ?? 0
    return dateB - dateA
  })

export const mapSessionHistoryListItems = (
  events: SessionHistoryEvent[],
): SessionHistoryListItem[] =>
  events.map((event, index) => ({
    ...event,
    id: `${event.sessionId || 'event'}-${event.time}-${index}`,
  }))

export const HISTORY_RETENTION_NOTICE = 'Historique conservé 365 jours.'
